import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].GET_REGULATIONS_TARGET_PRODUCTS]: {
		url:'/company/:companyId/regulations/:regulationId/target_products/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].GET_REGULATIONS_TARGET_PRODUCT_PREVIEW]: {
		url: '/company/:companyId/regulations/:regulationId/target_products/:targetProductId/preview/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].GET_REGULATIONS_TARGET_PRODUCT_POPUP]: {
		url: '/company/:companyId/regulations/:regulationId/target_products/:targetProductId/popup/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].GET_REGULATIONS_TARGET_PRODUCT]: {
		url: '/company/:companyId/regulations/:regulationId/target_products/:targetProductId/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].CREATE_REGULATIONS_TARGET_PRODUCT]: {
		url:'/company/:companyId/regulations/:regulationId/target_products/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].PATCH_REGULATIONS_TARGET_PRODUCT]: {
		url: '/company/:companyId/regulations/:regulationId/target_products/:targetProductId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].PUT_REGULATIONS_TARGET_PRODUCT]: {
		url: '/company/:companyId/regulations/:regulationId/target_products/:targetProductId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].DELETE_REGULATIONS_TARGET_PRODUCT]: {
		url: '/company/:companyId/regulations/:regulationId/target_products/:targetProductId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}